// Story 65.37 — a "mesma ação". A trava de um pedido por vez precisa saber se o segundo clique
// é o mesmo pedido que já saiu (dois cliques no mesmo botão) ou outro (a linha de baixo da mesma
// lista). A resposta está no que é enviado: dois pedidos são a mesma ação quando o conteúdo é
// igual. Texto, número, data, lista e objeto simples são comparados pelo valor, sem depender da
// ordem das chaves. Arquivo, formulário de envio e qualquer outro objeto próprio são comparados
// por identidade: o mesmo arquivo é a mesma ação, outro arquivo é outra. O evento do clique não
// faz parte da ação: todo clique no mesmo botão é o mesmo gesto.

const identities = new WeakMap<object, number>();
let lastIdentity = 0;

function identityOf(value: object): number {
  let id = identities.get(value);
  if (id === undefined) {
    lastIdentity += 1;
    id = lastIdentity;
    identities.set(value, id);
  }
  return id;
}

const isEvent = (value: object): boolean => typeof (value as { preventDefault?: unknown }).preventDefault === 'function' && 'target' in value;

export function actionKey(value: unknown): string {
  const open = new Set<object>();
  const write = (item: unknown): string => {
    if (item === null) return 'null';
    if (typeof item === 'string') return JSON.stringify(item);
    if (typeof item === 'number' || typeof item === 'boolean' || typeof item === 'bigint' || typeof item === 'undefined') return String(item);
    if (typeof item === 'symbol') return item.toString();
    if (typeof item === 'function') return `fn#${identityOf(item)}`;
    const object = item as object;
    if (object instanceof Date) return `date:${object.getTime()}`;
    if (isEvent(object)) return 'event';
    if (open.has(object)) return `loop#${identityOf(object)}`;
    if (Array.isArray(object)) {
      open.add(object);
      const body = object.map(write).join(',');
      open.delete(object);
      return `[${body}]`;
    }
    const proto = Object.getPrototypeOf(object) as object | null;
    if (proto !== Object.prototype && proto !== null) return `obj#${identityOf(object)}`;
    open.add(object);
    const record = object as Record<string, unknown>;
    const body = Object.keys(record).sort().map((key) => `${JSON.stringify(key)}:${write(record[key])}`).join(',');
    open.delete(object);
    return `{${body}}`;
  };
  return write(value);
}
